import { useSearchParams } from 'react-router-dom';

export const useRouterExternal = () => {
  const [searchParams] = useSearchParams();
  const pathname = searchParams.get('pathname');
  const pt = searchParams.get('pt');


  return {
    pushExternal: (callBackUrl: string, token: string) => {
      if (!callBackUrl) {
        alert("it hasn't callbackUrl");
        return;
      }
      if (
        window.api?.APP_ENV === 'development' ||
        pt?.toLowerCase().includes('kahkeshan')
      ) {
        window.location.href =
          callBackUrl +
          '/connect/authorize' +
          '?client_id=' +
          token +
          '&brokerCode=' +
          window.api?.BROKER_CODE +
          (!!pathname ? '&pathname=' + pathname.replace(/^(\/)*/g, '/') : '');
        return;
      }
      window.location.href =
        callBackUrl + (!!pathname ? '/' + pathname.replace(/^\//, '') : '');
    },
  };
};
